import Navbar from "../components/shared/Navbar";
import Footer from "../components/shared/Footer";

const Privacy = () => {
  return (
    <>
      <Navbar solid />

      <div className="bg-[#F8FAFC] py-10 md:py-14">
        <div className="container mx-auto px-8 md:px-20">
          <div className="bg-white border border-gray-200 rounded-[8px] p-6 md:p-10 shadow-sm">
            <h1 className="text-3xl md:text-4xl font-bold text-[#333333] mb-6">
              CCCSNV Privacy Policy
            </h1>

            <p className="text-[#1F2937] mb-6 leading-7">
              CCCSNV, developed by CCC, India, is committed to protecting your
              personal data and complying with the General Data Protection
              Regulation (GDPR). This Privacy Policy explains what personal data
              we collect, how we use it, and your rights regarding your data.
            </p>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              Information We Collect
            </h2>
            <p className="text-[#1F2937] mb-3 leading-7">
              We collect the following personal data from you when you use
              CCCSNV:
            </p>
            <ul className="list-disc pl-6 text-[#1F2937] mb-6 leading-7">
              <li>Full Name</li>
              <li>Email Address</li>
              <li>Mobile Number</li>
              <li>Education Details</li>
              <li>Work Experience</li>
              <li>Profile Picture</li>
              <li>Address</li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              How We Use Your Data
            </h2>
            <p className="text-[#1F2937] mb-3 leading-7">
              We use your personal data to provide and improve our resume
              building services. Specifically, we use it for:
            </p>
            <ul className="list-disc pl-6 text-[#1F2937] mb-6 leading-7">
              <li>Creating and managing your account.</li>
              <li>Providing personalized resume templates.</li>
              <li>
                Communicating with you about your account and our services.
              </li>
              <li>
                Improving our website and services based on your feedback.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              Legal Basis for Processing
            </h2>
            <p className="text-[#1F2937] mb-6 leading-7">
              Our legal basis for collecting and using your personal data is
              your consent, which you provide when you use our services and
              accept this Privacy Policy.
            </p>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              Data Sharing and Disclosure
            </h2>
            <p className="text-[#1F2937] mb-3 leading-7">
              We do not share your personal data with third parties except as
              necessary to provide our services or comply with legal
              obligations. Specifically, we may share your data with:
            </p>
            <ul className="list-disc pl-6 text-[#1F2937] mb-6 leading-7">
              <li>Google, for authentication purposes via Google Login.</li>
              <li>
                Service providers who assist us in operating our website and
                services.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              Contact Us
            </h2>
            <p className="text-[#1F2937] leading-7">
              Email: support@cccsnv.com
              <br />
              Address: CCC Digital Private Ltd 101, 1st Floor, Elemental #337,
              Road No. 1, Financial District, Hyderabad, Telangana 500032
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Privacy;
